export default "__VITE_ASSET__C1jjhp6J__"